import React from "react";
import "./login.css";

const Login: React.FC = () => {
    return (
      <div className="">
        Login
      </div>
    );  
  };
  export default Login;